import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    connect() {
        // Restore scroll position when frame loads
        this.restoreScrollPosition()

        // Update active state based on current URL (desktop only)
        this.updateActiveChat()

        // Listen for navigation events
        document.addEventListener('turbo:load', this.handleNavigation.bind(this))
        document.addEventListener('turbo:before-visit', this.saveScrollPosition.bind(this))
    }

    disconnect() {
        document.removeEventListener('turbo:load', this.handleNavigation.bind(this))
        document.removeEventListener('turbo:before-visit', this.saveScrollPosition.bind(this))
    }

    handleNavigation() {
        this.restoreScrollPosition()
        this.updateActiveChat()
    }

    saveScrollPosition() {
        // Find the actual scrolling container - the ChatList card or its parent
        const scrollContainer = this.getScrollContainer()
        if (scrollContainer) {
            const scrollTop = scrollContainer.scrollTop
            sessionStorage.setItem('chatListScrollPosition', scrollTop)
        }
    }

    restoreScrollPosition() {
        // Find the actual scrolling container - the ChatList card or its parent
        const scrollContainer = this.getScrollContainer()
        if (scrollContainer) {
            const savedPosition = sessionStorage.getItem('chatListScrollPosition')
            if (savedPosition !== null) {
                // Use requestAnimationFrame to ensure DOM is ready
                requestAnimationFrame(() => {
                    scrollContainer.scrollTop = parseInt(savedPosition, 10)
                })
            }
        }
    }

    getScrollContainer() {
        // The scrolling happens on the ChatList card itself or the ChatList__Chats div
        // Try both to find which one is actually scrolling
        const chatList = this.element.closest('.ChatList')
        const chatsContainer = this.element.querySelector('.ChatList__Chats')

        // Return whichever has overflow scrolling enabled
        if (chatList && chatList.scrollHeight > chatList.clientHeight) {
            return chatList
        }
        if (chatsContainer && chatsContainer.scrollHeight > chatsContainer.clientHeight) {
            return chatsContainer
        }

        return chatList || chatsContainer
    }

    updateActiveChat() {
        // Skip active state on native clients because it breaks the UI
        // Native clients handle selection state through their own navigation stack
        if (Paige.isNative()) {
            return
        }

        // Get current chat ID from URL
        const urlParams = new URLSearchParams(window.location.search)
        const currentChatId = urlParams.get('id') || this.extractChatIdFromPath()

        // Remove all active classes
        this.element.querySelectorAll('.ChatList__Chat').forEach((chat) => {
            chat.classList.remove('active')
        })

        // Add active class to current chat
        if (currentChatId) {
            const activeChat = this.element.querySelector(`a[href*="${currentChatId}"]`)
            if (activeChat) {
                activeChat.classList.add('active')
            }
        }
    }

    extractChatIdFromPath() {
        // Extract chat ID from path like /chats/chat-123-456
        const pathMatch = window.location.pathname.match(/\/chats\/(.+)/)
        return pathMatch ? pathMatch[1] : null
    }
}
